export const calculeTotalCostProducts = (array: any) => {
  if (!array) return []
  return array.reduce((acc: any, cur: any) => {
    return acc + (cur?.margin?.costValue || 0) * cur.quantity
  }, 0)
}
